(() => {
  const section = document.getElementById('CeroOfficeNewsletter');
  const form = document.getElementById('CeroOfficeForm');
  const dialog = document.getElementById('CeroOfficeInvitation');
  if (!section || !form) return;
  const preferences = form.querySelector('[data-office-preferences]');
  const tags = form.querySelector('[data-office-tags]');
  const whatsappField = form.querySelector('[data-office-whatsapp]');
  const whatsappInput = form.querySelector('[data-office-whatsapp-input]');
  function normalizeWhatsApp(value) {
    const normalized = value.trim().replace(/[\s().-]/g,'');
    return normalized === '' || /^\+[1-9]\d{7,14}$/.test(normalized) ? normalized : null;
  }
  const dismissedKey = 'cero_office_invitation_dismissed_v1';
  const subscribedKey = 'cero_office_subscribed_v1';
  const allowed = {style:['formal','smart_casual','relaxed'],top:['S','M','L','XL','2XL','3XL'],pants:['30','32','34','36','38']};
  function syncTags() {
    if (!tags) return;
    const values = ['newsletter','office_3d','office_consent_v2','office_waitlist','office_source_global'];
    const whatsappNumber = whatsappInput ? normalizeWhatsApp(whatsappInput.value) : '';
    if (whatsappInput) whatsappInput.setCustomValidity(whatsappNumber === null ? whatsappInput.dataset.officeWhatsappError : '');
    if (whatsappNumber) values.push(`office_whatsapp_${whatsappNumber}`,'office_whatsapp_record_only_v1');
    form.querySelectorAll('[data-office-pref]').forEach(field => {
      const key = field.dataset.officePref;
      if (allowed[key] && allowed[key].includes(field.value)) values.push(`office_${key}_${field.value}`);
    });
    Array.from(tags.options).forEach(option => {
      const language = option.dataset.officeLanguage;
      if (['es','en','pt'].includes(language)) option.value = [...values,`office_lang_${language}`].join(',');
    });
  }
  if (whatsappField && whatsappInput && tags) {
    whatsappField.hidden = false;
    whatsappInput.disabled = false;
    whatsappInput.addEventListener('input',syncTags);
  }
  if (preferences) {
    preferences.hidden = false;
    form.addEventListener('change',syncTags);
    form.addEventListener('submit',event=>{
      syncTags();
      if (!form.checkValidity()) {event.preventDefault();form.reportValidity();}
    });
    syncTags();
  }
  const success = form.querySelector('[data-office-success]');
  if (success) {
    try {localStorage.setItem(subscribedKey,'1');} catch {}
    success.focus({preventScroll:true});
    section.scrollIntoView({block:'center'});
    return;
  }
  if (form.querySelector('[role="alert"]')) {
    section.scrollIntoView({block:'center'});
    const email = document.getElementById('CeroOfficeEmail');
    if (email) email.focus({preventScroll:true});
    return;
  }
  const shipping = document.getElementById('CeroShippingInvitation');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const shippingKey = 'cero_free_shipping99_closed_v2';
  const quietKey = 'cero_promo_quiet_until_v1';
  let quietUntil = 0;
  let activeDialog = null;
  let timer;
  let stopped = false;
  const started = Date.now();
  const expires = started + 120000;
  function read(storage,key) {try {return window[storage].getItem(key);} catch {return null;}}
  function write(storage,key,value) {try {window[storage].setItem(key,value);} catch {}}
  quietUntil = Number(read('sessionStorage',quietKey)||0);
  let shippingPending = Boolean(shipping) && read('localStorage',shippingKey)!=='1';
  const dismissed = Number(read('localStorage',dismissedKey)||0);
  let officePending = section.dataset.officeSubscribed!=='true' && section.dataset.officePopup==='true' && read('localStorage',subscribedKey)!=='1' && !(dismissed>0 && Date.now()-dismissed<30*24*60*60*1000);
  function schedule(delay=2000) {
    clearTimeout(timer);
    if (!stopped && (shippingPending || officePending) && Date.now()<expires) timer=window.setTimeout(attempt,delay);
  }
  function isBusy() {
    const active=document.activeElement;
    if (document.hidden || section.contains(active) || active?.matches('input,select,textarea,[contenteditable="true"]')) return true;
    return Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"],.welcome15-backdrop.is-visible')).some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden');
  }
  function attempt() {
    if (activeDialog || stopped || Date.now()>=expires) return;
    if (Date.now()<quietUntil || isBusy()) {schedule();return;}
    const bounds=section.getBoundingClientRect();
    if(bounds.top<innerHeight && bounds.bottom>0) {schedule();return;}
    let next=null;
    if(shippingPending) next=shipping;
    else if(officePending) {
      if (Date.now()<started+12000) {schedule(started+12000-Date.now());return;}
      next=dialog;
    }
    if(!next) return;
    activeDialog=next;
    if(next===shipping) shippingPending=false;
    else officePending=false;
    next.showModal();
  }
  function afterClose(closed) {
    if (closed===shipping) write('localStorage',shippingKey,'1');
    else write('localStorage',dismissedKey,String(Date.now()));
    if(activeDialog===closed) activeDialog=null;
    quietUntil=Date.now()+15000;
    write('sessionStorage',quietKey,String(quietUntil));
    schedule(15000);
  }
  dialog.querySelectorAll('[data-office-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('close',()=>afterClose(dialog));
  dialog.querySelector('[data-office-open-form]').addEventListener('click',()=>{
    stopped=true;
    clearTimeout(timer);
    dialog.close();
    section.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    const email=document.getElementById('CeroOfficeEmail');
    if(email) email.focus({preventScroll:true});
  });
  if(shipping) {
    shipping.querySelectorAll('[data-shipping-close]').forEach(button=>button.addEventListener('click',()=>shipping.close()));
    shipping.addEventListener('close',()=>afterClose(shipping));
    shipping.querySelector('[data-shipping-shop]').addEventListener('click',()=>{
      stopped=true;
      clearTimeout(timer);
      shipping.close();
    });
  }
  schedule(shippingPending?700:12000);
})();
